import { useAuthContext } from '../hooks/useAuth';

/**
 * Shown when an authenticated user is not flagged `is_admin` in
 * `profiles`. The Pages Functions enforce the same check before any
 * data flows — this is the friendly client-side surface for the
 * same gate.
 */
export function AdminGate() {
  const { profile, signOut } = useAuthContext();

  return (
    <div className="center-page">
      <div className="card" style={{ maxWidth: 480, width: '100%' }}>
        <h1 style={{ margin: '0 0 6px', fontSize: 22, letterSpacing: '-0.02em' }}>
          Admins only
        </h1>
        <p style={{ margin: '0 0 16px', color: 'var(--color-text-muted)' }}>
          You're signed in as <strong>{profile?.email ?? profile?.full_name ?? 'unknown'}</strong>,
          but this account doesn't have admin access. Ask the team to
          enable it for you.
        </p>
        <button type="button" className="btn btn-secondary" onClick={() => void signOut()}>
          Sign out
        </button>
      </div>
    </div>
  );
}
